import { useLayoutEffect, useMemo } from 'react';
import { DEFAULT_CONNECTION_RADIUS, DEFAULT_DELETE_KEY_CODE } from '../../core';
import { useStoreApi } from '../../store';
import type { EngineProps } from './CustomMindmap.types';

/** Copies drag, connect, delete and element-event options and callbacks into the store. */
export const useInteractionSync = ({
  nodesDraggable = true,
  onNodeDragStart,
  onNodeDrag,
  onNodeDragStop,
  nodesConnectable = true,
  connectOnClick = true,
  connectionRadius = DEFAULT_CONNECTION_RADIUS,
  onConnect,
  onConnectStart,
  onConnectEnd,
  onNodesDelete,
  onEdgesDelete,
  deleteKeyCode = DEFAULT_DELETE_KEY_CODE,
  onNodeClick,
  onNodeDoubleClick,
  onNodeMouseEnter,
  onNodeContextMenu,
  onEdgeClick,
  onEdgeContextMenu,
  onPaneContextMenu,
}: EngineProps): void => {
  const store = useStoreApi();
  const dragHandlers = useMemo(() => ({ onNodeDragStart, onNodeDrag, onNodeDragStop }), [onNodeDragStart, onNodeDrag, onNodeDragStop]);
  const connectHandlers = useMemo(() => ({ onConnect, onConnectStart, onConnectEnd }), [onConnect, onConnectStart, onConnectEnd]);
  const connectOptions = useMemo(
    () => ({ nodesConnectable, connectOnClick, connectionRadius }),
    [nodesConnectable, connectOnClick, connectionRadius],
  );

  useLayoutEffect(() => {
    store.getState().setNodesDraggable(nodesDraggable);
  }, [store, nodesDraggable]);
  useLayoutEffect(() => {
    store.getState().setDragHandlers(dragHandlers);
  }, [store, dragHandlers]);
  useLayoutEffect(() => {
    store.getState().setConnectHandlers(connectHandlers);
  }, [store, connectHandlers]);
  useLayoutEffect(() => {
    store.getState().setConnectOptions(connectOptions);
  }, [store, connectOptions]);
  const deleteHandlers = useMemo(() => ({ onNodesDelete, onEdgesDelete }), [onNodesDelete, onEdgesDelete]);
  useLayoutEffect(() => {
    store.getState().setDeleteHandlers(deleteHandlers);
  }, [store, deleteHandlers]);
  useLayoutEffect(() => {
    store.getState().setDeleteKeyCode(deleteKeyCode);
  }, [store, deleteKeyCode]);
  const elementHandlers = useMemo(
    () => ({ onNodeClick, onNodeDoubleClick, onNodeMouseEnter, onNodeContextMenu, onEdgeClick, onEdgeContextMenu, onPaneContextMenu }),
    [onNodeClick, onNodeDoubleClick, onNodeMouseEnter, onNodeContextMenu, onEdgeClick, onEdgeContextMenu, onPaneContextMenu],
  );
  useLayoutEffect(() => {
    store.getState().setElementHandlers(elementHandlers);
  }, [store, elementHandlers]);
};
